import type { Tag } from '@tribeplatform/gql-client/types'
import { useSpaceTags, useSortedTags } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'
import { Multiselect } from '@tribeplatform/react-ui-kit/Multiselect'

import { useI18n } from '../i18n/index.js'

interface Props {
  value: string[]
  options: string[]
  onChange: (tagIds: string[]) => void
  placeholder?: string
  noWrapper?: boolean
  className?: string
}
export const TagPickerFromIds = ({
  value,
  options,
  onChange,
  placeholder,
  noWrapper,
  className,
}: Props) => {
  const { $t } = useI18n()
  const { data, isInitialLoading } = useSpaceTags({
    variables: { ids: options, limit: options.length },
    useInfiniteQueryOptions: {
      enabled: options.length > 0,
    },
  })
  const { nodes: tagOptions } = simplifyPaginatedResult<Tag>(data)

  const getPlaceHolder = () => {
    if (isInitialLoading || !tagOptions) {
      return $t({
        id: 'Generics.LoadingDotDotDot',
        defaultMessage: 'Loading...',
      })
    }

    return placeholder
  }

  const { sortedTags } = useSortedTags({
    tags: tagOptions,
    sortOrderTagIds: options,
  })

  const { sortedTags: sortedSelectedTags } = useSortedTags({
    tags: tagOptions,
    sortOrderTagIds: value,
  })

  return (
    <Multiselect
      value={value}
      options={options}
      onChange={newValues => onChange(newValues)}
      disabled={isInitialLoading}
      className={className}
    >
      <Multiselect.Button placeholder={getPlaceHolder()}>
        {sortedSelectedTags &&
          sortedSelectedTags
            .filter(({ id }) => value.includes(id))
            .map((tag, index) => (
              <Multiselect.SelectedItem
                key={tag.id}
                value={tag.id}
                index={index}
              >
                <span className="truncate">{tag.title}</span>
              </Multiselect.SelectedItem>
            ))}
      </Multiselect.Button>
      <Multiselect.Items noWrapper={noWrapper}>
        {sortedTags &&
          sortedTags.map((tag, index) => (
            <Multiselect.Item key={tag.id} value={tag.id} index={index}>
              <span className="truncate">{tag.title}</span>
            </Multiselect.Item>
          ))}
      </Multiselect.Items>
    </Multiselect>
  )
}
